export const base_api_url = "https://api.hazecrypto.net/Api/Admin/";
export const apiEndPoint = "https://api.hazecrypto.net";



// WEBPACK FOOTER //
// ./src/config.js